import { BackendError } from "./BackendError";

export class ApiError extends Error {
  constructor(public backendError: BackendError) {
    super();
  }
}
